export default __webpack_public_path__ + "static/media/Defunc.5035ea51.svg";